var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { changeFavoriteBetAmount as changeFavoriteBetAmountAction } from '../../../actions/creators/favoriteAmounts';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import SettingsImg from '../../../assets/img/settings.svg';
import SettingsBtnImg from '../../../assets/img/polygon_1.svg';
import FavouriteBet from '../FavouriteBet';
import OneTouchBet from './OneTouchBet';
import AutoConfirm from './AutoConfirm';
import Switcher from '../Switcher';
var defaultBet1 = 1;
var defaultBet2 = 5;
var defaultBet3 = 10;
var defaultBet4 = 30;
var messages = defineMessages({
    sidebar_settings: {
        id: 'sidebar.settings',
        defaultMessage: 'Settings'
    },
    sidebar_fav_stakes: {
        id: 'sidebar.fav_stakes',
        defaultMessage: 'Favourite stakes'
    },
    one_touch_bet: {
        id: 'one.touch_bet',
        defaultMessage: 'One-touch bet'
    },
    coupon_settings_txt: {
        id: 'coupon.settings_txt',
        defaultMessage: 'Betslip settings'
    },
    auto_confirm: {
        id: 'auto.confirm',
        defaultMessage: 'Automatically confirm'
    },
    increasing_the_ratio: {
        id: 'increasing.the_ratio',
        defaultMessage: 'Increasing the ratio'
    },
    decreasing_the_ratio: {
        id: 'decreasing.the_ratio',
        defaultMessage: 'Decreasing the ratio'
    }
});
var Settings = /** @class */ (function (_super) {
    __extends(Settings, _super);
    function Settings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toggledFavStake: true
        };
        _this.saveFavourite = function (e) {
            localStorage.setItem(e.target.name, e.target.value);
            _this.props.changeFavoriteBetAmountAction({ target: e.target.name, amount: e.target.value });
            _this.setState({
                favBet1: localStorage.getItem('favorite_1'),
                favBet2: localStorage.getItem('favorite_2'),
                favBet3: localStorage.getItem('favorite_3'),
                favBet4: localStorage.getItem('favorite_4')
            });
        };
        _this.toggleFavStakeHandler = function () {
            localStorage.setItem('toggledFavStake', JSON.stringify(!_this.state.toggledFavStake));
            _this.setState(function (prevState) { return ({
                toggledFavStake: !prevState.toggledFavStake
            }); });
        };
        return _this;
    }
    Settings.prototype.componentWillMount = function () {
        if (localStorage.getItem('favorite_1') === null) {
            localStorage.setItem('favorite_1', defaultBet1);
        }
        if (localStorage.getItem('favorite_2') === null) {
            localStorage.setItem('favorite_2', defaultBet2);
        }
        if (localStorage.getItem('favorite_3') === null) {
            localStorage.setItem('favorite_3', defaultBet3);
        }
        if (localStorage.getItem('favorite_4') === null) {
            localStorage.setItem('favorite_4', defaultBet4);
        }
        this.setState({
            favBet1: localStorage.getItem('favorite_1'),
            favBet2: localStorage.getItem('favorite_2'),
            favBet3: localStorage.getItem('favorite_3'),
            favBet4: localStorage.getItem('favorite_4')
        });
    };
    Settings.prototype.render = function () {
        var _a = this.state, favBet1 = _a.favBet1, favBet2 = _a.favBet2, favBet3 = _a.favBet3, favBet4 = _a.favBet4;
        var settingsIsOpened = this.props.settingsIsOpened;
        localStorage.setItem('toggledFavStake', JSON.stringify(this.state.toggledFavStake));
        var couponSettings;
        var btnImgClassName;
        var couponListClass;
        if (!settingsIsOpened) {
            btnImgClassName = 'toggled-up';
            couponSettings = '';
            couponListClass = '';
        }
        else {
            btnImgClassName = 'toggled-down';
            couponListClass = 'list-with-border';
            var toggledDivClassName = void 0;
            this.state.toggledFavStake ? toggledDivClassName = 'toggle-div__inner toggled' : toggledDivClassName = 'toggle-div__inner';
            couponSettings = (_jsxs("ul", { children: [_jsx("li", { children: _jsx(OneTouchBet, { switcherTxt: _jsx(FormattedMessage, __assign({}, messages.one_touch_bet)) }) }), _jsx("li", { children: _jsx(AutoConfirm, { autoConfirmTxt: _jsx(FormattedMessage, __assign({}, messages.auto_confirm)), increaseTxt: _jsx(FormattedMessage, __assign({}, messages.increasing_the_ratio)), decreaseTxt: _jsx(FormattedMessage, __assign({}, messages.decreasing_the_ratio)) }) }), _jsx("li", { children: _jsx("div", __assign({ className: 'forms stake' }, { children: _jsxs("div", __assign({ className: 'stake-variants' }, { children: [_jsx(Switcher, { switcherTxt: this.props.intl.formatMessage(messages.sidebar_fav_stakes), onclick: this.toggleFavStakeHandler, class: toggledDivClassName }), this.state.toggledFavStake &&
                                        _jsxs("div", __assign({ className: 'stake-variants__inputs' }, { children: [_jsx(FavouriteBet, { state: this.state, name: 'favorite_1', saveFavourite: this.saveFavourite, value: favBet1 }), _jsx(FavouriteBet, { name: 'favorite_2', saveFavourite: this.saveFavourite, value: favBet2 }), _jsx(FavouriteBet, { name: 'favorite_3', saveFavourite: this.saveFavourite, value: favBet3 }), _jsx(FavouriteBet, { name: 'favorite_4', saveFavourite: this.saveFavourite, value: favBet4 })] }))] })) })) })] }));
        }
        return (_jsx("li", __assign({ className: 'settings' }, { children: _jsxs("div", __assign({ className: 'coupon-settings' }, { children: [_jsx("ul", __assign({ style: { borderBottom: 'none' } }, { children: _jsxs("li", __assign({ className: couponListClass }, { children: [_jsx("img", { src: SettingsImg, alt: 'settings' }), _jsxs("button", __assign({ onClick: this.props.toggleSettingsBlock }, { children: [_jsx("p", { children: this.props.intl.formatMessage(messages.coupon_settings_txt) }), _jsx("img", { className: btnImgClassName, src: SettingsBtnImg, alt: 'arrow' })] }))] })) })), couponSettings] })) })));
    };
    return Settings;
}(React.Component));
Settings.propTypes = {
    changeFavoriteBetAmountAction: PropTypes.func.isRequired,
    toggleSettingsBlock: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) {
    return {
        favoriteAmounts: state.application.get('favoriteAmounts'),
    };
};
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeFavoriteBetAmountAction: changeFavoriteBetAmountAction
}, dispatch); };
Settings = connect(mapStateToProps, mapDispatchToProps)(Settings);
export default injectIntl(Settings);



// WEBPACK FOOTER //
// ./src/components/sidebar/settings/Settings.jsx